export const CATEGORY_LIST = [
  {
    key: 'all',
    label: 'All Tiles',
    description: 'Browse our complete collection of premium porcelain and wood-look tiles.',
  },
  {
    key: 'porcelain',
    label: 'Porcelain',
    description: 'Dense, durable porcelain tiles in a wide range of sizes and finishes.',
  },
  {
    key: 'woodLook',
    label: 'Wood Look',
    description: 'The warmth of timber with the durability of porcelain.',
  },
];
